__turbopack_context__.v({
  "avatar": "ReviewPlatformProofModule-module__oNlqtG__avatar",
  "card": "ReviewPlatformProofModule-module__oNlqtG__card",
  "carousel": "ReviewPlatformProofModule-module__oNlqtG__carousel",
  "controls": "ReviewPlatformProofModule-module__oNlqtG__controls",
  "counter": "ReviewPlatformProofModule-module__oNlqtG__counter",
  "eyebrow": "ReviewPlatformProofModule-module__oNlqtG__eyebrow",
  "fallback": "ReviewPlatformProofModule-module__oNlqtG__fallback",
  "googleMark": "ReviewPlatformProofModule-module__oNlqtG__googleMark",
  "header": "ReviewPlatformProofModule-module__oNlqtG__header",
  "metrics": "ReviewPlatformProofModule-module__oNlqtG__metrics",
  "module": "ReviewPlatformProofModule-module__oNlqtG__module",
  "navigation": "ReviewPlatformProofModule-module__oNlqtG__navigation",
  "ratingOnly": "ReviewPlatformProofModule-module__oNlqtG__ratingOnly",
  "review": "ReviewPlatformProofModule-module__oNlqtG__review",
  "reviewLink": "ReviewPlatformProofModule-module__oNlqtG__reviewLink",
  "reviewMeta": "ReviewPlatformProofModule-module__oNlqtG__reviewMeta",
  "reviewer": "ReviewPlatformProofModule-module__oNlqtG__reviewer",
  "skeleton": "ReviewPlatformProofModule-module__oNlqtG__skeleton",
  "sources": "ReviewPlatformProofModule-module__oNlqtG__sources",
  "stars": "ReviewPlatformProofModule-module__oNlqtG__stars",
  "status": "ReviewPlatformProofModule-module__oNlqtG__status",
});
